import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./Residue.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext"; 
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";


import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}




function Residue() {

    useEffect(() => {
    
      trackPageVisit("Residue");
    
    }, []);
  
     const {  valves, toggleValve} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
  const {processData,  setProcessData} = useContext(ProcessContext);

     

  const DEFAULT_VALVES = {
  FCV_3401: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3402: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3403: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3404: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("Residue_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_3401: { ...DEFAULT_VALVES.FCV_3401, ...parsed.FCV_3401 },
      FCV_3402: { ...DEFAULT_VALVES.FCV_3402, ...parsed.FCV_3402 },
      FCV_3403: { ...DEFAULT_VALVES.FCV_3403, ...parsed.FCV_3403 },
      FCV_3404: { ...DEFAULT_VALVES.FCV_3404, ...parsed.FCV_3404 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("Residue_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const [panelPos, setPanelPos] = useState({ x: 0, y: 80 });
const [dragging, setDragging] = useState(false);
const offsetRef = useRef({ x: 0, y: 0 });

const handleMouseDown = (e) => {
  setDragging(true);

  offsetRef.current = {
    x: e.clientX - panelPos.x,
    y: e.clientY - panelPos.y,
  };
};

const handleMouseMove = (e) => {
  if (!dragging) return;

  setPanelPos({
    x: e.clientX - offsetRef.current.x,
    y: e.clientY - offsetRef.current.y,
  });
};

const handleMouseUp = () => {
  setDragging(false);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [dragging]);




const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };


// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================
    
                const { transmitters,  } = usePlantStore();
                const TT_3310 = transmitters.TT_3310 || 0;
                const PT_33010 = transmitters.PT_33010 || 0;
                const FIC_33010 = transmitters.FIC_33010 || 0;
  




  const xv3401Open = !valves?.XV_3401;
  const xv3402Open = !valves?.XV_3402;
  const xv3403Open = !valves?.XV_3403;
  const xv3404Open = !valves?.XV_3404;
  const xv3405Open = !valves?.XV_3405;
  const xv3406Open = !valves?.XV_3406;


    const FIC_3401 = FIC_33010;
    const PT_3401 = PT_33010;


    
/* =========================================================
              SPLITTING MAIN NAPHTHA LINE
========================================================= */

const openResidueTankSplit =
[
  xv3401Open,
  xv3402Open
].filter(Boolean).length;

const FIC_3402 =
  xv3401Open
    ? FIC_3401 / openResidueTankSplit
    : 0;

const FIC_3403 =
  xv3402Open
    ? FIC_3401 / openResidueTankSplit
    : 0;






/* =========================================================
   PUMP CONTEXT
========================================================= */

const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};
const togglePump = pumpContext.togglePump || (() => {});

/* =========================================================
   P-3401A / P-3401B STATUS
========================================================= */

const P3401A_Running =
pumpData?.["P-3401A"]?.running ?? false;

const P3401B_Running =
pumpData?.["P-3401B"]?.running ?? false;

const P3401_Running =
P3401A_Running || P3401B_Running;


/* =========================================================
   PUMP CAPACITY
========================================================= */

const P3401_CAPACITY = 12.5;


/* =========================================================
   CONTROL VALVE
========================================================= */

const FCV3401_Opening =
(valveData?.FCV_3401?.opening || 0) / 100;


/* =========================================================
   TARGET FLOW
========================================================= */

const targetFIC3404 =
(
P3401_Running
)
?
P3401_CAPACITY *
FCV3401_Opening
:
0;


/* =========================================================
   FLOW UPDATE
========================================================= */

useEffect(()=>{

const timer=setInterval(()=>{

setProcessData(prev=>{

const current =
Number(prev.FIC_3404 || 0);

const next =
current +
(targetFIC3404-current)*0.12;

return{

...prev,

FIC_3404:
Number(next.toFixed(3))

};

});

},500);

return()=>clearInterval(timer);

},
[
targetFIC3404
]);



/* =========================================================
   PRESSURE + TEMPERATURE ENGINE
========================================================= */

useEffect(()=>{

const timer=setInterval(()=>{

setProcessData(prev=>{

const currentPressure =
Number(prev.PT_3404 || 0.03);

const currentTemp =
Number(prev.TT_3404 || 28);

const currentFlow =
Number(prev.FIC_3404 || 0);

let targetPressure = 0.03;
let targetTemp = 28;


/* =========================================
   PUMP RUNNING
========================================= */

if(P3401_Running){

/* -----------------------------------------
   PRESSURE
----------------------------------------- */

// Dead-head (Valve fully closed)

if(FCV3401_Opening<=0){

targetPressure=1.80;

}

// Highly restricted

else if(FCV3401_Opening<0.20){

const restriction =
(0.20-FCV3401_Opening)/0.20;

targetPressure=
0.80+
restriction*
1.00;

}

// Normal operation

else{

targetPressure=
0.80-
(
FCV3401_Opening-
0.20
)*0.18;

}


/* -----------------------------------------
   TEMPERATURE
----------------------------------------- */

targetTemp=28;

// Dead-head heating

if(FCV3401_Opening<=0){

targetTemp=36;

}

// Restricted flow heating

else if(FCV3401_Opening<0.20){

const restriction=
(0.20-FCV3401_Opening)/0.20;

targetTemp=
28+
restriction*4;

}

}


/* =========================================
   UPDATE
========================================= */

return{

...prev,

PT_3404:
Number(
(
currentPressure+
(
targetPressure-currentPressure
)*0.08
).toFixed(3)
),

TT_3404:
Number(
(
currentTemp+
(
targetTemp-currentTemp
)*0.08
).toFixed(2)
)

};

});

},500);

return()=>clearInterval(timer);

},
[
P3401_Running,
FCV3401_Opening
]);


/* =========================================================
   TRANSMITTERS
========================================================= */

const FIC_3404 =
Number(
processData.FIC_3404 || 0
);

const PT_3404 =
Number(
processData.PT_3404 || 0.03
);

const TT_3404 =
Number(
processData.TT_3404 || 28
);





/* =========================================================
   V-3401 SUCTION FLOW
========================================================= */
const FIC_3405 = (P3401A_Running && xv3403Open) ? FIC_3404 : 0.003;

/* =========================================================
   V-3402 SUCTION FLOW
========================================================= */
const FIC_3406 = (P3401A_Running && xv3404Open) ? FIC_3404 : 0.003;











    
/* =========================================================
              SPLITTING MAIN RESIDUE LINE
========================================================= */



const openResidueLineSplit =
[
  xv3405Open,
  xv3406Open
].filter(Boolean).length;

const FIC_3407 =
  xv3405Open
    ? FIC_3404 / openResidueLineSplit
    : 0;

const FIC_3408 =
  xv3406Open
    ? FIC_3404 / openResidueLineSplit
    : 0;





useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.FIC_3407 === FIC_3407 
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      FIC_3407,
    }
  });

}, [FIC_3407, ]);













  return (
    <div className="Residue-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "240px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 353px",
          zIndex: 10,
        }}
      >
        RESIDUE TANKS
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-3401 */}
      <Valve
        className="XV-3401"
        tag="XV_3401"
        x={314}
        y={355}
        isClosed={valves.XV_3401}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-3402 */}
      <Valve
        className="XV-3402"
        tag="XV_3402"
        x={774}
        y={355}
        isClosed={valves.XV_3402}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-3403 */}
      <Valve
        className="XV-3403"
        tag="XV_3403"
        x={534}
        y={365}
        isClosed={valves.XV_3403}
        toggle={toggleValve}
      />

      {/* XV-3404 */}
      <Valve
        className="XV-3404"
        tag="XV_3404"
        x={1083}
        y={355}
        isClosed={valves.XV_3404}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-3405 */}
      <Valve
        className="XV-3405"
        tag="XV_3405"
        x={1033}
        y={561}
        isClosed={valves.XV_3405}
        toggle={toggleValve}
      />

      {/* XV-3406 */}
      <Valve
        className="XV-3406"
        tag="XV_3406"
        x={1033}
        y={671}
        isClosed={valves.XV_3406}
        toggle={toggleValve}
      />




      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-3401 */}
        <div
            style={{ position: "absolute", left: 865, top: 553}}
            onMouseEnter={() => setHoveredValve("FCV_3401")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_3401")}
          >

            {hoveredValve === "FCV_3401" && (
              <div style={tagStyle}>
                FCV_3401
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-3401">
                    
          <defs>
            <linearGradient id="metal_3401">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_3401)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_3401)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
     
      
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 340 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 340 + index * 40
              }}
            />
          ))}





      {/* ================= CONTROL VALVE OUTPUTS ================= */}


      <ValveOutput
        value={Number(valveData?.FCV_3401?.opening || 0)}
        x={887}
        y={600}
      />




    <Transmitter
        tag="FIC_3401"
        value={[FIC_3401]}
        x={121}
        y={325}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF ATMOSPHERIC RESIDUE FROM E-117A/B TO RESIDUE STORAGE TANKS"
      />

    <Transmitter
        tag="PT_3401"
        value={[PT_3401]}
        x={181}
        y={455}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF ATMOSPHERIC RESIDUE FROM E-117A/B TO RESIDUE STORAGE TANKS"
      />

      <Transmitter
        tag="FIC_3402"
        value={[FIC_3402]}
        x={281}
        y={255}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF ATMOSPHERIC RESIDUE FROM E-117A/B TO RESIDUE STORAGE TANKS (V-401)"
      />

      <Transmitter
        tag="FIC_3403"
        value={[FIC_3403]}
        x={741}
        y={255}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF ATMOSPHERIC RESIDUE FROM E-117A/B TO RESIDUE STORAGE TANKS (V-402)"
      />

      <Transmitter
        tag="FIC_3404"
        value={[FIC_3404]}
        x={783}
        y={593}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF ATMOSPHERIC RESIDUE FROM P-3401A/B TO LOADING OR BLENDING"
      />


      <Transmitter
        tag="PT_3404"
        value={[PT_3404]}
        x={683}
        y={593}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF ATMOSPHERIC RESIDUE FROM P-3401A/B TO LOADING OR BLENDING"
      />
    
    <Transmitter
        tag="TT_3404"
        value={[TT_3404]}
        x={683}
        y={503}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF ATMOSPHERIC RESIDUE FROM P-3401A/B TO LOADING OR BLENDING"
      />

      <Transmitter
        tag="FIC_3407"
        value={[FIC_3407]}
        x={1113}
        y={553}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF ATMOSPHERIC RESIDUE FROM P-3401A/B TO LOADING GANTRY"
      />

      <Transmitter
        tag="FIC_3408"
        value={[FIC_3408]}
        x={1113}
        y={663}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF ATMOSPHERIC RESIDUE FROM P-3401A/B TO FUEL OIL BLENDING TANK"
      />






      <LevelTransmitterIndicator
      tag="LT_3401"
      totalLevel={65000}
      inflows={[FIC_3402]}
      outflows={[FIC_3405]}
      responseFactor={0.05}
      columnX={563}
      columnY={139}
      columnWidth={30}
      columnHeight={179}
      textX={610}
      textY={150}
      showFlow={true}
      service="residue"
    />

    <LevelTransmitterIndicator
      tag="LT_3401"
      totalLevel={65000}
      inflows={[FIC_3402]}
      outflows={[FIC_3405]}
      responseFactor={0.05}
      columnX={396}
      columnY={139}
      columnWidth={199}
      columnHeight={181}
      textX={610}
      textY={150}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.1}
      service="residue"
    />


      <LevelTransmitterIndicator
      tag="LT_3402"
      totalLevel={65000}
      inflows={[FIC_3403]}
      outflows={[FIC_3406]}
      responseFactor={0.05}
      columnX={1009}
      columnY={139}
      columnWidth={30}
      columnHeight={179}
      textX={1050}
      textY={150}
      showFlow={true}
      service="residue"
    />

    <LevelTransmitterIndicator
      tag="LT_3402"
      totalLevel={65000}
      inflows={[FIC_3403]}
      outflows={[FIC_3406]}
      responseFactor={0.05}
      columnX={841}
      columnY={139}
      columnWidth={199}
      columnHeight={181}
      textX={1050}
      textY={150}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.1}
      service="residue"
    />



            <Pump
              tag="P-3401A"
              x={568}
              y={520}
              rpm={1800}
              bladeCount={pumpData?.["P-3401A"]?.bladeCount || 3}
              size={pumpData?.["P-3401A"]?.size || 45}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-3401B"
              x={568}
              y={614}
              rpm={1800}
              bladeCount={pumpData?.["P-3401B"]?.bladeCount || 3}
              size={pumpData?.["P-3401B"]?.size || 45}
              onClick={openPumpPanel}
            />






    </div>
  );
}

export default Residue;